// @flow

import React from 'react';

// header

type Props = {
    value: string,
    handleFilterChange: Function
};

const PlayerFilter = (props: Props) => {
    const display = (
        <div style={{ paddingBottom: '10px' }}>
            <input
                name="player-search-filter"
                placeholder="Search Player"
                className="Select-control"
                style={{ paddingLeft: '10px' }}
                onChange={e => props.handleFilterChange(e, 'Player')}
                value={props.value}
            />
        </div>
    );

    return display;
};

export default PlayerFilter;



// WEBPACK FOOTER //
// ./src/components/Main/Filters/PlayerFilter.js